import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { noteEmailClick } from "../lib/emailClick";

// A tap on a talent email's button (?em=<the email's name>) is logged once and
// em leaves the address bar: lib/emailClick has the rules.
//
// Mounted once, next to DeepLinkHandler and BEFORE <Routes>. React runs the
// effects of siblings in order, so the tap is logged before a page's own
// redirect effect moves on: /open/payouts → /requests?payouts=1, the sign-in
// guard → /login?next=…, /profile → /requests#profile.
//
// Runs on every navigation (the location object, not just its query): the
// router keeps the em it already read, so a navigation built from it can put
// em back in the address bar with the same query, and it comes out again.
const EmailClickTracker: React.FC = () => {
  const location = useLocation();
  useEffect(() => {
    noteEmailClick(location.search);
  }, [location]);
  return null;
};

export default EmailClickTracker;
